var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"bounce"}},[(_vm.isShow)?_c('div',{staticClass:"message"},[_c('span',[_vm._v(_vm._s(_vm.info))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }